<template>
    <div class="col-picker">
        <div class="topX"><slot name="close"></slot></div>
        
        <div v-if="collections.activeCollectionItems.length==0" class="noColMsg">
            {{localize('no_items_list')}}
        </div>

        <div class="mainControls" v-if="collections.activeCollectionItems.length>0">
            <div class="top">
                <span class="topTitle">{{localize('my_list')}}</span>                
                <span class="btnDowbload" @click="downloadList()">
                    <i class="fal fa-arrow-down"></i>
                    &nbsp;
                    {{localize('Download')}}
                </span>
                <span class="btnDowbload" @click="deleteCollection()">
                    <i class="fal fa-trash"></i>
                    &nbsp;
                    {{localize('Clear all')}}
                </span>

                <!-- FOR USING MULTIPLE COLLECTIONS: -->
                <!--
                    <div class="selectorFrame">
                        <select :v-model="activeColItem" @change="onChange($event)" name="colSelector" id="selectCol1" class="colSelector textbox">
                            <option :selected="item.collection.col_id == activeColItem" v-for="(item, index) in collections.children" 
                            :key="index" v-bind:value="item.collection.col_id">
                                {{item.collection.col_name}}
                            </option>
                        </select>
                    </div>
                    <a class="deleteCol" @click="deleteCollection()"><i class="fal fa-trash-alt"></i><span>Delete Collection</span></a>
                -->
            </div>
            
            <!-- PRODUCTS GRID -->
            <div class="products">
                <preloader key="preloader" v-if="loadingData" class="products_loader" />
                <template v-if="!loadingData">
                    <div v-for="item in itemsData.items" class="item" :key="item.product.PRO_ID">
                        
                        <!-- remove from colelction -->
                        <div :title="localize('remove_item')" class="remove-from-col" 
                                @click="removeItem(item.item.item_id)">
                            <i class="fal fa-minus"></i>  
                        </div>
                        <router-link class="item"                    
                            target="_blank"
                            :title="item.product.CatalogNo"                    
                            :to="`/product/${item.product.CatalogNo}`">  
                            <!-- todo add to .item-preview: margin-bottom: 5em; -->
                            <catalog-thumb :specs="item.specsRows" :item="item.product" :size="big"></catalog-thumb>
                        </router-link>
                    </div>
                </template>
            </div>

            <!-- share collection -->
            <div class="shareSection">
                <div class="shareTitle">{{localize('share_list')}}</div>
                <div style="clear:both;" class="shareRow">
                    <input readonly id="linkToShare" ref="shareRef" 
                        :class="[isCopyingLink ? 'copying' : '','shareLink','textbox']" v-model="shareLink" />
                    <a class="copyLink" @click="copyShareLink()">
                        <i class="fal fa-copy"></i>
                        <span>{{localize('Copy')}}</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapState, mapActions, mapGetters } from "vuex";
import CatalogThumb from "@/components/catalog/CatalogThumb.vue";
export default {  
  data() {
    return {
        loadingData:true,
        shareLink:'',
        itemsData:null,
        isCopyingLink:false

    };
  },
  components: {CatalogThumb},
  
  methods: 
  {
    ...mapActions(["closeCollectionsViewer","setItemToCollect","setCollectionsList","setActiveCollection","updateStoreCollection"]),
    removeItem(collectionItemID)
    {
        var vm=this;
        var apiURL = "https://api.mis-implants.com/api/collections?AUID="+
            vm.auid+"&CollectionID="+
            vm.collections.activeCollection+"&CollectionItemID="+collectionItemID
            +"&ln="+vm.locale.ln;

        fetch(apiURL,{method: 'DELETE',mode: 'cors',cache: 'no-cache',headers: {'Content-Type': 'application/json','Access-Control-Allow-Origin': '*'}})
        .then(function(response){return response.json();})
        .then(function(response){
            vm.readCollectionItems(vm.collections.activeCollection);
            vm.updateStoreCollection();
        });         
    },
    initData()
      {
            var vm=this;
            vm.readCollections();
      },
      closeViewer()
      {
        vm.closeCollectionsViewer();
      },
    copyShareLink()
    {
        var vm=this;
        let testingCodeToCopy = document.getElementById("linkToShare");
        testingCodeToCopy.select()
        try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'successful' : 'unsuccessful';
            vm.isCopyingLink = true;
        } catch (err) {
            alert('Oops, unable to copy');
        }
        window.getSelection().removeAllRanges()    
        setTimeout(() => {
            vm.isCopyingLink = false;            
        }, 10);        
    },
    updateShareLink()
    {
        this.shareLink="https://www.mis-implants.com/user-collection"+
            "?auid="+this.auid+"&id="+this.collections.activeCollection;
    },
    onChange(event) {
        var cid = event.target.value;
        this.setActiveCollection(cid)
        this.readCollectionItems(cid);
        this.updateShareLink();
    },
    readCollectionItems(CollectionID)
    {        
        var vm=this;
        vm.loadingData=true;    
        var apiURL = "https://api.mis-implants.com/api/collections?AUID="+
            vm.auid+"&CollectionID="+CollectionID+"&ln="+vm.locale.ln;
        fetch(apiURL,{method: 'GET',mode: 'cors',cache: 'no-cache',headers: {'Content-Type': 'application/json','Access-Control-Allow-Origin': '*'}})
        .then(function(response){return response.json();})
        .then(function(response){
            vm.itemsData = response;
            //alert("items loaded");
            setTimeout(() => {
                vm.loadingData=false;
            }, 300);
        });         
    },
    downloadList()
    {
        //"collection-259b749ce52a4fa1a8d3b2680cfcf144"
        var vm=this;        
        var apiURL = "https://api.mis-implants.com/api/CollectionReport?AUID="+
            vm.auid+"&CollectionID="+vm.collections.activeCollection
            +"&ln="+vm.locale.ln;
            
        fetch(apiURL,
        {
            headers: {'Content-Type': 'application/json','Access-Control-Allow-Origin': '*'},
            method: 'POST',mode: 'cors',cache: 'no-cache'                
        })
        .then(function(response){return response.json();})
        .then(function(response)
        {
            var ft = response;
            var DOWNLOAD_URL = "https://www.mis-implants.com/upload/reports/"+ft+".xlsx";
            //"https://api.mis-implants.com/api/CollectionReport?t="+ft;
            window.location =  DOWNLOAD_URL;

            //https://api.mis-implants.com/api/CollectionReport?t=collection-259b749ce52a4fa1a8d3b2680cfcf144
            //collection-259b749ce52a4fa1a8d3b2680cfcf144
        });        
    },
    readCollections()
    {
        var vm=this;
        var apiURL = "https://api.mis-implants.com/api/collections?AUID="+vm.auid;
        fetch(apiURL,{method: 'GET',mode: 'cors',cache: 'no-cache',headers: {'Content-Type': 'application/json','Access-Control-Allow-Origin': '*'}})
        .then(function(response){return response.json();})
        .then(function(response)
        {
            vm.setCollectionsList(response);//update the list
            if(vm.collections.activeCollection==-1){
                //no active collection, select the first collection
                if(vm.collections.children.length>0){
                    var firstItemID = vm.collections.children[0].collection.col_id;
                    //alert("firstItemID="+firstItemID);
                    vm.setActiveCollection(firstItemID);
                    vm.updateShareLink();
                }
            }
            vm.updateShareLink();
            vm.readCollectionItems(vm.activeColItem);
        });         
    },
    deleteCollection()
    {
        var vm=this;        
        if (confirm("Are you sure you want to delete this collection?") == false) {
            return false;
        } 
        var apiURL = "https://api.mis-implants.com/api/collections?AUID="+
            vm.auid+"&CollectionID="+vm.collections.activeCollection
            +"&ln="+vm.locale.ln;
            fetch(apiURL,{method: 'DELETE',mode: 'cors',cache: 'no-cache',
            headers: {'Content-Type': 'application/json','Access-Control-Allow-Origin': '*'}})
            .then(function(response){return response.json();})
            .then(function(response){
                vm.setActiveCollection(-1);//remove active collection value
                vm.readCollections();
                vm.readCollectionItems(vm.collections.activeCollection);
                vm.updateStoreCollection();
            });
    }
  },
  mounted()
  {
    var vm=this;            
    vm.initData();
  },
  created(){
  },
  watch:
  {
    "collection.activeCollection"() 
    {
      //alert("changed to:"+this.collection.activeCollection);
    },
  },
  computed: 
  {
    ...mapState(["collections","auid","locale"]),
    ...mapGetters(["getItemToCollect","getAUID"]),
    activeColItem() {
      return this.collections.activeCollection;
    }
  }
};
</script>

<style lang="stylus" scoped>
  .remove-from-col
    opacity 1
    cursor pointer !important
    background-color #fff
    color #6d6d6d
    width 24px
    height 24px
    position absolute
    right 10px
    top 10px
    text-align center
    border-radius 15px
    z-index 1000
    &:hover
      background-color #31a9f6
      color #fff
    i
      position relative
      top 2px
    
</style>

<style scoped>
    .noColMsg
    {
        position: relative;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        text-align: center;
        font-weight: bold;
    }
    .col-picker
    {
        z-index: 2000;
        position: fixed;
        top: 50%;
        left:50vw;
        width: 700px;
        height: 85vh;
        max-height: 85vh;
        background-color: #fff;
        color: black;
        border-radius: 15px;
        transform: translate(-50%,-50%);          
        box-shadow: 0px 0px 36.1px 1.9px rgba(107, 107, 107, 0.25);
    }
    .topX
    {
        position: absolute;
        text-align: left;
        right: 0px;
        padding: 30px;
        z-index: 3000;
    }
    .mainControls
    {
        float: left;
        padding: 0px 30px;
        width:100%;
    }
    .mainControls .top
    {
        padding-top: 30px;
    }
    .topTitle
    {
        color: #31a9f6;
        font-size: 18px;
        font-weight: 300 !important;
    }
    .btnDowbload i
    {
        font-size: 12px;padding-right: 4px;
        position: relative;
        top:1px;
    }
    .btnDowbload
    {
        cursor: pointer;
        margin-left: 10px;
        font-size: 13px;
        padding: 10px 20px;
        border-radius: 30px;
        font-weight: 400;
        transition: all ease-in-out 0.2s;
        -webkit-transition: all ease-in-out 0.2s;
    }
    .btnDowbload:hover
    {
        color:#fff;
        background-color: #31a9f6;
    }





    .mainControls .top > *
    {
        vertical-align: middle;
    }
    .top .deleteCol
    {
        padding-left: 20px;
        color:#7e7e7e;
        font-size: 14px;
        position: relative;
        top:8px;
        cursor: pointer;
    }
    .deleteCol span
    {
        padding-left: 5px;
    }
    .deleteCol:hover span
    {
        color: #31a9f6;
    }



    .textbox
    {
        padding: 10px 15px;
        border-radius: 20px;
        border:0px;
        background-color: #fcfcfc;        
    }
    .selectorFrame
    {        
        float: left;
        border:solid 1px #ddd;
        background-color: #fcfcfc;
        padding-right: 15px;
        border-radius: 20px;
    }
    .colSelector
    {
        width: 300px;
        float: left;
        font-weight: 500 !important;
        color: #31a9f6;        
    }
    .textbox:focus
    {
        outline: none;
    }


    .btnClose
    {        
        position: absolute;
        top:20px;right: 15px;
        width: 30px;height: 30px;
        cursor: pointer !important;
        font-size: 30px;
        opacity: 0.3;
    }
    .btnClose:hover
    {
        opacity: 1;
    }
    .items
    {
        width: 100%;
    }
    .items .item
    {
        clear: both;
        width: 100%;
        background-color: #fff;
        padding: 20px 30px;
        position: relative;
        height: 60px;
    }
    .items .item:hover
    {
        background-color: #f8f8f8;
    }
    .itemPic
    {
        background-size: cover;
        background-image: url(https://www.mis-implants.com/upload/catalog/products/thumbs/V3-13390.png);
        background-color: #f9f9f9;
        width: 40px;
        height: 40px;
        float: left;
        border-radius: 20px;
        position: absolute;
        top: 10px;
    }
    .itemAddIcon
    {
        width: 40px;
        height: 40px;
        float: left;
        border-radius: 20px;
        position: absolute;
        top: 10px;
        background-color: #f9f9f9;
        text-align:center;
    }
    .itemAddIcon i
    {
        font-size: 24px;position: relative;top:7px;
        
    }
    .itemName
    {
        float: left;
        padding-left: 50px;
    }
    .itemBtn
    {
        background-color: #31a9f6;
        border-radius: 20px;
        color: #fff;
        display: inline-block;
        float: right;
        padding: 8px 15px;
        position: absolute;
        top: 13px;
        right: 30px;
        cursor: pointer;
        opacity: 0;
        font-weight: 300 !important;

    }
    .items .item:hover .itemBtn
    {
        opacity: 1;
    }

    .itemName input
    {
        padding: 8px 5px !important;
        width: 250px;
        border:solid 1px #ccc;
        position: relative;
        top:-7px
    }
    .itemName input:focus
    {
        outline: none;
    }
    .products_loader
    {
        padding-top: 30px;
        height: calc(80vh - 170px);
        float: left;
    }
    .products
    {
        padding-top: 30px;
        width:100%;
        position: relative;
        display: grid;
        width: 100%;
        margin: initial;
        grid-template-columns: 1fr 1fr 1fr;
        column-gap: 20px;
        row-gap: 7em;
        padding-bottom: 30px;        
        height: calc(80vh - 170px);
        overflow-y: auto;
        border:solid 0px red;
    }
    .products .item {
        box-sizing: border-box;
        position: relative;
    }
    .products .item span {
        color: white;
        margin: 30px;
        font-size: 30px;
    }

    .shareSection
    {
        clear: both;
        padding-top: 35px;
    }
    .shareTitle
    {
        clear: both;
        font-size: 16px;
        font-weight: 300 !important;
    }
    .shareRow
    {
        clear: both;
        padding-top: 10px;
    }
    .shareLink
    {
        width: calc(100% - 115px);
        float: left;
        font-weight: 500 !important;
        color: #7e7e7e;
        border:solid 1px #ddd;
        font-size: 11px;
        transition: ease-in all 0.2s;
    }
    .shareLink.copying
    {
        background-color:#31a9f6 ;
        color:#fff;
    }    
    .copyLink
    {
        cursor: pointer;
        background-color: #31a9f6;
        padding: 10px 15px;
        border-radius: 20px;
        float: left;
        position: relative;
        left: 20px;
    }
    .copyLink i
    {
        color:#fff;
    }
    .copyLink span
    {
        color:#fff;
        padding-left: 10px;
        font-weight: 500px;
        font-size: 14px;
    }
    



    @media only screen and (max-width: 800px) {
        .col-picker
        {
            width: 100vw;
            min-height: 100vh;
            top:0px;left: 0px;
            transform: none;
        }        
        .colSelector {
            width: 88%;
        }        
        .top .deleteCol{
            clear: both;
            display: block;
            float: left;
            padding: 15px 5px;
        }        
        .products
        {
            grid-template-columns: 1fr 1fr;
            height: calc(80vh - 133px);
        }        
    }

</style>
